<div class="logo" class:home="{$location.path === '/'}">
    <a href="/"><img src="logo.png" alt="halbsicht logo" /></a>
    <div class="links" use:links>
        {#each linklist as l}
            <div>
                <a
                    href="{l.href}"
                    target="{l.external ? '_blank' : ''}"
                >{l.name}</a>
            </div>
        {/each}
    </div>
</div>

<Router url="{url}">
    <Route path="/:page" let:params>
        <div class="page">
            {#await lade('/pages/' + params.page)}
                lade ...
            {:then page}
                <Markdown source="{page}" />
            {/await}
        </div>
    </Route>
</Router>

<style lang="less" global>:global(body) {
  background-color: black;
  color: white;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 14px;
}
:global(a) {
  color: #999;
  text-transform: uppercase;
  text-decoration: none;
}
:global(a:hover) {
  color: #fff;
}
:global(div.logo) {
  top: 0px;
  left: 0px;
  transition-property: top, left;
  transition: all 0.3s ease-in-out;
  display: flex;
}
:global(div.logo) :global(img) {
  width: 100px;
  margin-right: 40px;
}
:global(div.logo) :global(.links) :global(div) {
  padding-top: 5px;
}
:global(div.logo.home) {
  display: block;
  margin: auto;
  width: 300px;
  height: 300px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
:global(div.logo.home) :global(img) {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  width: 211px;
}
:global(div.logo.home) :global(.links) {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
:global(div.logo.home) :global(.links) :global(div) {
  text-align: center;
}
:global(.page) {
  background-color: white;
  color: black;
  margin: 20px;
  padding: 20px;
  -webkit-box-shadow: 0px 0px 15px 5px #ffffff;
  box-shadow: 0px 0px 15px 5px #ffffff;
  border-radius: 10px;
}
:global(.page) :global(a) {
  color: #333;
}
:global(.page) :global(a:hover) {
  color: black;
}
</style>

<script lang="typescript">import {Router, Route, links} from "svelte-routing";
import {scrollToTop} from "svelte-scrollto";
import {location} from "../store";
import Markdown from "./Markdown.svelte";
const linklist = window._config.links;
let url = "";
if (url) {
  let l = url.split("?");
  $location = {
    path: l[0],
    search: l.length > 1 ? l[1] : "",
    categoryPath: l[0].replace(/\/\d{4,99}[^\/]+$/, ""),
    push: false,
    pop: false
  };
}
location.subscribe((l) => {
  if (l.push)
    scrollToTop();
});
if (typeof window !== "undefined")
  console.log("App initialized");
async function lade(url2) {
  const r = await fetch(url2);
  const t = await r.text();
  return t;
}
export {
  url
};
</script>
